import _ from "lodash";
import app_math from "./math.js";
import superconsole from "./superconsole.js";

const hk = {
  ulje: {
    rs: 1.2,
    bg: 1.1,
    ro: null,
    hr: 1.1,
    si: 1.1,
    gr: 1.1,
    tr: null,
    hu: 1,
    sk: 1.35,
    cz: null,
    pl: 1.1,
    ee: null,
    lt: null,
  },
  mazut: {
    rs: null,
    bg: 1.1,
    ro: null,
    hr: null,
    si: null,
    gr: 1.1,
    tr: null,
    hu: null,
    sk: null,
    cz: null,
    pl: 1.1,
    ee: null,
    lt: 1.1,
  },
  kerozin: {
    rs: 1.1,
    bg: null,
    ro: null,
    hr: null,
    si: null,
    gr: null,
    tr: null,
    hu: null,
    sk: null,
    CZ: null,
    pl: null,
    ee: null,
    lt: null,
  },
  gas: {
    rs: 1.1,
    bg: 1.1,
    ro: 1.1,
    hr: 1.1,
    si: 1.1,
    gr: 1.05,
    tr: null,
    hu: 1,
    sk: 1.36,
    cz: 1.1,
    pl: 1.1,
    ee: null,
    lt: null,
  },
  propan: {
    rs: null,
    bg: 1.1,
    ro: null,
    hr: 1.1,
    si: null,
    gr: null,
    tr: null,
    hu: 1,
    sk: null,
    cz: null,
    pl: 1.1,
    ee: null,
    lt: null,
  },
  ugalj: {
    rs: 1.3,
    bg: 1.2,
    ro: 1.2,
    hr: 1.1,
    si: null,
    gr: null,
    tr: null,
    hu: 1,
    sk: null,
    cz: null,
    pl: 1.2,
    ee: null,
    lt: null,
  },
  lignit: {
    rs: null,
    bg: 1.2,
    ro: 1.3,
    hr: 1.2,
    si: null,
    gr: null,
    tr: null,
    hu: 1,
    sk: 1.5,
    cz: null,
    pl: 1.2,
    ee: null,
    lt: null,
  },
  antracit: {
    rs: null,
    bg: 1.2,
    ro: null,
    hr: 1.1,
    si: null,
    gr: null,
    tr: null,
    hu: 1,
    sk: 1.19,
    cz: null,
    pl: 1.2,
    ee: null,
    lt: null,
  },
  briketi_od_uglja: {
    rs: null,
    bg: 1.25,
    ro: null,
    hr: null,
    si: null,
    gr: null,
    tr: null,
    hu: 1,
    sk: null,
    cz: null,
    pl: 1.25,
    ee: "",
    lt: null,
  },
  pelet: {
    rs: null,
    bg: 1.05,
    ro: 1.08,
    hr: 0.2,
    si: null,
    gr: null,
    tr: null,
    hu: 0.6,
    sk: 1.1,
    cz: 0.15,
    pl: 1.05,
    ee: null,
    lt: null,
  },
  biomasa: {
    rs: 0.1,
    bg: null,
    ro: 1.08,
    hr: 0.2,
    si: 0.1,
    gr: 1,
    tr: null,
    hu: 0.6,
    sk: 0.1,
    cz: 0.05,
    pl: 0.2,
    ee: null,
    lt: null,
  },
  centralno: {
    rs: 1.8,
    bg: 1.3,
    ro: null,
    hr: 1.3,
    si: 1.2,
    gr: 1.26,
    tr: null,
    hu: null,
    sk: null,
    cz: null,
    pl: 1.3,
    ee: null,
    lt: null,
  },
  kogeneracija: {
    rs: 1,
    bg: null,
    ro: 0.92,
    hr: 0.7,
    si: 1,
    gr: 0.83,
    tr: null,
    hu: null,
    sk: null,
    cz: null,
    pl: null,
    ee: null,
    lt: null,
  },
  struja: {
    rs: 2.5,
    bg: 3,
    ro: 2.62,
    hr: 3,
    si: 2.5,
    gr: 2.9,
    tr: null,
    hu: 2.5,
    sk: 2.8,
    cz: 3,
    pl: 3,
    ee: null,
    lt: null,
  },
  struja_PV: {
    rs: null,
    bg: null,
    ro: null,
    hr: null,
    si: null,
    gr: null,
    tr: null,
    hu: null,
    sk: null,
    cz: null,
    pl: 0.7,
    ee: null,
    lt: null,
  },
  split: {
    rs: 1,
    bg: 1,
    ro: 1,
    hr: 1,
    si: 1,
    gr: 1,
    tr: 1,
    hu: 1,
    sk: 1,
    cz: 1,
    pl: 1,
    ee: 1,
    lt: 1,
  },
  ground: {
    rs: 1,
    bg: 1,
    ro: 1,
    hr: 1,
    si: 1,
    gr: 1,
    tr: 1,
    hu: 1,
    sk: 1,
    cz: 1,
    pl: 1,
    ee: 1,
    lt: 1,
  },
};

const co2k = {
  ulje: {
    rs: 0.28,
    bg: 0.267,
    ro: 0.29,
    hr: 0.28,
    si: 0.28,
    gr: 0.264,
    tr: 0.23,
    hu: null,
    sk: 0.33,
    CZ: null,
    pl: 0.279,
    ee: null,
    lt: null,
  },
  mazut: {
    rs: null,
    bg: 0.279,
    ro: null,
    hr: null,
    si: null,
    gr: 0.264,
    tr: null,
    hu: null,
    sk: null,
    CZ: null,
    pl: null,
    ee: null,
    lt: 0.28,
  },
  kerozin: {
    rs: 0.26,
    bg: null,
    ro: null,
    hr: null,
    si: null,
    gr: null,
    tr: null,
    hu: null,
    sk: null,
    CZ: null,
    pl: null,
    ee: null,
    lt: null,
  },
  gas: {
    rs: 0.2,
    bg: 0.202,
    ro: 0.23,
    hr: 0.2,
    si: 0.2,
    gr: 0.196,
    tr: 0.2,
    hu: null,
    sk: 0.27,
    CZ: null,
    pl: 0.202,
    ee: null,
    lt: null,
  },
  propan: {
    rs: null,
    bg: 0.227,
    ro: null,
    hr: 0.22,
    si: null,
    gr: null,
    tr: null,
    hu: null,
    sk: null,
    CZ: null,
    pl: null,
    ee: null,
    lt: null,
  },
  ugalj: {
    rs: null,
    bg: 0.341,
    ro: 0.33,
    hr: null,
    si: null,
    gr: null,
    tr: null,
    hu: null,
    sk: null,
    CZ: null,
    pl: null,
    ee: null,
    lt: null,
  },
  lignit: {
    rs: 0.33,
    bg: 0.364,
    ro: 0.33,
    hr: null,
    si: 0.33,
    gr: null,
    tr: 0.34,
    hu: null,
    sk: 0.433,
    CZ: null,
    pl: 0.341,
    ee: null,
    lt: null,
  },
  antracit: {
    rs: null,
    bg: 0.354,
    ro: 0.4,
    hr: null,
    si: null,
    gr: null,
    tr: null,
    hu: null,
    sk: 0.394,
    CZ: null,
    pl: 0.354,
    ee: null,
    lt: null,
  },
  briketi_od_uglja: {
    rs: null,
    bg: 0.351,
    ro: null,
    hr: null,
    si: null,
    gr: null,
    tr: null,
    hu: null,
    sk: 0.02,
    CZ: null,
    pl: null,
    ee: null,
    lt: null,
  },
  pelet: {
    rs: null,
    bg: 0.43,
    ro: null,
    hr: null,
    si: null,
    gr: null,
    tr: 0,
    hu: null,
    sk: 0.014,
    CZ: null,
    pl: null,
    ee: null,
    lt: null,
  },
  biomasa: {
    rs: null,
    bg: null,
    ro: 0.02,
    hr: null,
    si: null,
    gr: 0,
    tr: 0,
    hu: null,
    sk: 0.004,
    CZ: null,
    pl: null,
    ee: null,
    lt: null,
  },
  centralno: {
    rs: 0.33,
    bg: 0.29,
    ro: 0.36,
    hr: 0.33,
    si: 0.33,
    gr: null,
    tr: null,
    hu: null,
    sk: null,
    CZ: null,
    pl: null,
    ee: null,
    lt: null,
  },
  kogeneracija: {
    rs: null,
    bg: null,
    ro: 0.3,
    hr: null,
    si: null,
    gr: null,
    tr: null,
    hu: null,
    sk: null,
    CZ: null,
    pl: null,
    ee: null,
    lt: null,
  },
  struja: {
    rs: 0.53,
    bg: 0.819,
    ro: null,
    hr: 0.53,
    si: 0.53,
    gr: 0.989,
    tr: 0.55,
    hu: null,
    sk: 0.007,
    CZ: null,
    pl: 1.191,
    ee: null,
    lt: null,
  },
  struja_PV: {
    rs: null,
    bg: null,
    ro: null,
    hr: null,
    si: null,
    gr: null,
    tr: null,
    hu: null,
    sk: null,
    CZ: null,
    pl: null,
    ee: null,
    lt: null,
  },
  split: {
    rs: 0.5,
    bg: 0.5,
    ro: 0.5,
    hr: 0.5,
    si: 0.5,
    gr: 0.5,
    tr: 0.5,
    hu: 0.5,
    sk: 0.5,
    cz: 0.5,
    pl: 0.5,
    ee: 0.5,
    lt: 0.5,
  },
  ground: {
    rs: 0.4,
    bg: 0.4,
    ro: 0.4,
    hr: 0.4,
    si: 0.4,
    gr: 0.4,
    tr: 0.4,
    hu: 0.4,
    sk: 0.4,
    cz: 0.4,
    pl: 0.4,
    ee: 0.4,
    lt: 0.4,
  },
};

function get_first_not_null(obj) {
  for (const value of Object.values(obj)) {
    if (value != null) return value;
  }

  throw "NO DATA";
}

export default {
  get_solar_radiation(drzava, zona) {
    if (drzava === "rs") {
      return 1;
    } else if (drzava === "bg") {
      return 1;
    } else if (drzava === "ro") {
      return 1;
    } else if (drzava === "hr") {
      if (zona === 1) return 1;
      else if (zona === 2) return 1.1;
    } else if (drzava === "si") {
      return 0.95;
    } else if (drzava === "gr") {
      if (zona === "A") return 1.4;
      else if (zona === "B") return 1.3;
      else if (zona === "C") return 1.2;
      else if (zona === "D") return 1.1;
    } else if (drzava === "tr") {
      if (zona === "1") return 1.5;
      else if (zona === "2") return 1.4;
      else if (zona === "3") return 1.3;
      else if (zona === "4") return 1.2;
      else return 1.1; // ZONE 5 i 6
    } else if (drzava === "hu") {
      return 0.95;
    } else if (drzava === "sk") {
      return 0.9;
    } else if (drzava === "cz") {
      return 0.85;
    } else if (drzava === "pl") {
      return 0.8;
    } else if (drzava === "es") {
      return 0.7;
    } else if (drzava === "lt") {
      return 0.75;
    }
  },
  get_heating_koeficijent(drzava, tip) {
    if (tip == "neznam") throw "Nije definisan koeficijent";
    if (hk[tip][drzava] != null) {
      return hk[tip][drzava];
    } else {
      return get_first_not_null(hk[tip]);
    }
  },

  get_co2_koeficijent(drzava, tip) {
    if (tip == "neznam") throw "Nije definisan koeficijent";
    if (co2k[tip][drzava] != null) {
      return co2k[tip][drzava];
    } else {
      return get_first_not_null(co2k[tip]);
    }
  },
  get_max_u: function (drzava, zona, stanje, nagib, pos_status_value, basement, standardTypes) {
    if (!standardTypes || !standardTypes.length) standardTypes = [0];
    const final_u_max = {};
    for (const standard of standardTypes) {
      let umax = { 1: 0, 5: 0, 7: 0, 18: 0, 19: 0, 20: 0, 21: 0, 30: 0, 10: 0, 13: 0, 60: 0 };
      // umax_premium ne sadrzi key "30", za razliku od umax
      let umax_premium = { 1: 0, 5: 0, 7: 0, 18: 0, 19: 0, 20: 0, 21: 0, 10: 0, 13: 0, 60: 0 };
      if (drzava === "bg") {
        umax["1"] = 0.28;
        umax["5"] = 0.25;
        umax["7"] = 0.25;
        umax["18"] = 0.3;
        umax["19"] = 0.5;
        umax["20"] = 0.4;
        if (basement) {
          umax["21"] = 0.45;
        } else {
          umax["21"] = 0.4;
        }

        if (pos_status_value["10"]) {
          if (pos_status_value["10"].tip_prozora === 0) {
            // PVC
            umax["10"] = 1.4;
          } else if (pos_status_value["10"].tip_prozora === 1) {
            // WOODEN
            umax["10"] = 1.6;
          } else if (pos_status_value["10"].tip_prozora === 2) {
            // ALU
            umax["10"] = 1.7;
          }
        }

        umax["13"] = 2.2;

        if (pos_status_value["60"]) {
          if (pos_status_value["60"].tip_prozora === 0) {
            // PVC
            umax["60"] = 1.4;
          } else if (pos_status_value["60"].tip_prozora === 1) {
            // WOODEN
            umax["60"] = 1.6;
          } else if (pos_status_value["60"].tip_prozora === 2) {
            // ALU
            umax["60"] = 1.7;
          }
        }
      } else if (drzava === "sk") {
        if (pos_status_value["1"]) {
          if (standard === 0) {
            umax["1"] = 0.22;
          } else if (standard === 2) {
            umax["1"] = 0.15;
          }
        }
        if (pos_status_value["5"]) {
          if (standard === 0) {
            umax["5"] = 0.15;
          } else if (standard === 2) {
            umax["5"] = 0.1;
          }
        }
        if (pos_status_value["7"]) {
          if (standard === 0) {
            if (nagib === 1) {
              // manji od 45
              umax["7"] = 0.15;
            } else {
              umax["7"] = 0.22;
            }
          } else if (standard === 2) {
            if (nagib === 1) {
              // manji od 45
              umax["7"] = 0.1;
            } else {
              umax["7"] = 0.15;
            }
          }
        }
        if (pos_status_value["18"]) {
          if (standard === 0) {
            umax["18"] = 0.15;
          } else if (standard === 2) {
            umax["18"] = 0.15;
          }
        }
        if (pos_status_value["19"]) {
          if (standard === 0) {
            umax["19"] = 0.15;
          } else if (standard === 2) {
            umax["19"] = 0.15;
          }
        }
        if (pos_status_value["20"]) {
          if (standard === 0) {
            umax["20"] = 0.22;
          } else if (standard === 2) {
            umax["20"] = 0.15;
          }
        }
        if (pos_status_value["21"]) {
          if (standard === 0) {
            umax["21"] = 0.15;
          } else if (standard === 2) {
            umax["21"] = 0.15;
          }
        }
        if (pos_status_value["10"]) {
          if (standard === 0) {
            umax["10"] = 1;
          } else if (standard === 2) {
            umax["10"] = 0.6;
          }
        }
        if (pos_status_value["13"]) {
          if (standard === 0) {
            umax["13"] = 1;
          } else if (standard === 2) {
            umax["13"] = 0.6;
          }
        }
        if (pos_status_value["60"]) {
          if (standard === 0) {
            umax["60"] = 1;
          } else if (standard === 2) {
            umax["60"] = 0.6;
          }
        }
      } else if (drzava === "hr") {
        if (zona === 1) {
          umax["1"] = 0.3;
          umax["5"] = 0.25;
          umax["7"] = 0.25;
          umax["18"] = 0.4;
          umax["19"] = 0.25;
          umax["20"] = 0.3;
          umax["21"] = 0.3;
          umax["10"] = 1.4;
          umax["13"] = 2;
          umax["60"] = 1.4;
        } else if (zona === 2) {
          umax["1"] = 0.45;
          umax["5"] = 0.3;
          umax["7"] = 0.3;
          umax["18"] = 0.6;
          umax["19"] = 0.3;
          umax["20"] = 0.5;
          umax["21"] = 0.5;
          umax["10"] = 1.8;
          umax["13"] = 2.4;
          umax["60"] = 1.8;
        }
      
      } else if (drzava === "gr") {
        if (zona === "A") {
          umax["1"] = 0.6;
          umax["5"] = 0.5;
          umax["7"] = 0.5;
          umax["18"] = 1.2;
          umax["19"] = 1.2;
          umax["20"] = 1.5; // correct?
          umax["21"] = 1.2;
          umax["10"] = 3.2;
          umax["13"] = 3.2;
          umax["60"] = 3.2;

          umax_premium["1"] = 0.45;
          umax_premium["5"] = 0.4;
          umax_premium["7"] = 0.4;
          umax_premium["18"] = 1.0;
          umax_premium["19"] = 1.0;
          umax_premium["20"] = 1.4;
          umax_premium["21"] = 1.0;
          umax_premium["10"] = umax["10"];
          umax_premium["13"] = umax["13"];
          umax_premium["60"] = umax["60"];
        } else if (zona === "B") {
          umax["1"] = 0.5;
          umax["5"] = 0.45; // 0.45?
          umax["7"] = 0.45;
          umax["18"] = 0.9;
          umax["19"] = 0.9;
          umax["20"] = 1.0; // correct?
          umax["21"] = 0.9;
          umax["10"] = 3;
          umax["13"] = 3;
          umax["60"] = 3;

          umax_premium["1"] = 0.35;
          umax_premium["5"] = 0.3;
          umax_premium["7"] = 0.3;
          umax_premium["18"] = 0.7;
          umax_premium["19"] = 0.7;
          umax_premium["20"] = 0.9;
          umax_premium["21"] = 0.7;
          umax_premium["10"] = umax["10"];
          umax_premium["13"] = umax["13"];
          umax_premium["60"] = umax["60"];
        } else if (zona === "C") {
          umax["1"] = 0.45;
          umax["5"] = 0.4;
          umax["7"] = 0.4;
          umax["18"] = 0.75;
          umax["19"] = 0.75;
          umax["20"] = 0.8; // correct?
          umax["21"] = 0.75;
          umax["10"] = 2.8;
          umax["13"] = 2.8;
          umax["60"] = 2.8;

          umax_premium["1"] = 0.3;
          umax_premium["5"] = 0.25;
          umax_premium["7"] = 0.25;
          umax_premium["18"] = 0.6;
          umax_premium["19"] = 0.6;
          umax_premium["20"] = 0.7;
          umax_premium["21"] = 0.6;
          umax_premium["10"] = umax["10"];
          umax_premium["13"] = umax["13"];
          umax_premium["60"] = umax["60"];

        } else if (zona === "D") {
          umax["1"] = 0.4;
          umax["5"] = 0.35;
          umax["7"] = 0.35;
          umax["18"] = 0.7;
          umax["19"] = 0.7;
          umax["20"] = 0.7; // correct?
          umax["21"] = 0.7;
          umax["10"] = 2.6;
          umax["13"] = 2.6;
          umax["60"] = 2.6;

          umax_premium["1"] = 0.25;
          umax_premium["5"] = 0.22;
          umax_premium["7"] = 0.22;
          umax_premium["18"] = 0.5;
          umax_premium["19"] = 0.5;
          umax_premium["20"] = 0.6;
          umax_premium["21"] = 0.5;
          umax_premium["10"] = umax["10"];
          umax_premium["13"] = umax["13"];
          umax_premium["60"] = umax["60"];
        }
      } else if (drzava === "cz") {
        if (pos_status_value["1"]) {
          if (standard === 0) {
            if (pos_status_value["1"].laka_konstrukcija) {
              umax["1"] = 0.3;
            } else {
              umax["1"] = 0.38;
            }
          } else if (standard === 1) {
            if (pos_status_value["1"].laka_konstrukcija) {
              umax["1"] = 0.2;
            } else {
              umax["1"] = 0.25;
            }
          } else if (standard === 2) {
            if (pos_status_value["1"].laka_konstrukcija) {
              umax["1"] = 0.12;
            } else {
              umax["1"] = 0.18;
            }
          }
        }
        if (pos_status_value["5"]) {
          if (standard === 0) {
            umax["5"] = 0.24;
          } else if (standard === 1) {
            umax["5"] = 0.16;
          } else if (standard === 2) {
            if (pos_status_value["5"].laka_konstrukcija) {
              umax["5"] = 0.1;
            } else {
              umax["5"] = 0.15;
            }
          }
        }
        if (pos_status_value["7"]) {
          if (standard === 0) {
            if (nagib === 1) {
              // manje od 45'
              umax["7"] = 0.24;
            } else {
              if (pos_status_value["7"].laka_konstrukcija) {
                umax["7"] = 0.3;
              } else {
                umax["7"] = 0.38;
              }
            }
          } else if (standard === 1) {
            if (nagib === 1) {
              // manje od 45'
              umax["7"] = 0.16;
            } else {
              if (pos_status_value["7"].laka_konstrukcija) {
                umax["7"] = 0.2;
              } else {
                umax["7"] = 0.25;
              }
            }
          } else if (standard === 2) {
            if (nagib === 1) {
              // manje od 45'
              if (pos_status_value["7"].laka_konstrukcija) {
                umax["7"] = 0.1;
              } else {
                umax["7"] = 0.15;
              }
            } else {
              if (pos_status_value["7"].laka_konstrukcija) {
                umax["7"] = 0.12;
              } else {
                umax["7"] = 0.18;
              }
            }
          }
        }
        if (pos_status_value["18"]) {
          if (standard === 0) {
            umax["18"] = 0.6;
          } else if (standard === 1) {
            umax["18"] = 0.4;
          } else if (standard === 2) {
            if (pos_status_value["18"].laka_konstrukcija) {
              umax["18"] = 0.2;
            } else {
              umax["18"] = 0.3;
            }
          }
        }
        if (pos_status_value["19"]) {
          if (standard === 0) {
            umax["19"] = 0.6;
          } else if (standard === 1) {
            umax["19"] = 0.4;
          } else if (standard === 2) {
            if (pos_status_value["19"].laka_konstrukcija) {
              umax["19"] = 0.2;
            } else {
              umax["19"] = 0.3;
            }
          }
        }
        if (pos_status_value["20"]) {
          if (standard === 0) {
            umax["20"] = 0.45;
          } else if (standard === 1) {
            umax["20"] = 0.3;
          } else if (standard === 2) {
            if (pos_status_value["20"].laka_konstrukcija) {
              umax["20"] = 0.15;
            } else {
              umax["20"] = 0.22;
            }
          }
        }
        if (pos_status_value["21"]) {
          if (standard === 0) {
            umax["21"] = 0.45;
          } else if (standard === 1) {
            umax["21"] = 0.3;
          } else if (standard === 2) {
            if (pos_status_value["21"].laka_konstrukcija) {
              umax["21"] = 0.15;
            } else {
              umax["21"] = 0.22;
            }
          }
        }
        if (pos_status_value["10"]) {
          if (standard === 0) {
            umax["10"] = 1.7;
          } else if (standard === 1) {
            umax["10"] = 1.2;
          } else if (standard === 2) {
            umax["10"] = 0.9;
          }
        }
        if (pos_status_value["13"]) {
          if (standard === 0) {
            umax["13"] = 1.7;
          } else if (standard === 1) {
            umax["13"] = 1.2;
          } else if (standard === 2) {
            umax["13"] = 0.9;
          }
        }
        if (pos_status_value["60"]) {
          if (standard === 0) {
            umax["60"] = 1.7;
          } else if (standard === 1) {
            umax["60"] = 1.2;
          } else if (standard === 2) {
            umax["60"] = 0.9;
          }
        }
      } else if (drzava === "tr") {
        if (zona === 1) {
          umax["1"] = 0.7;
          umax["5"] = 0.45;
          umax["7"] = 0.45;
          umax["18"] = 0.7;
          umax["19"] = 0.7;
          umax["20"] = 0.6;
          umax["21"] = 0.7;
          umax["10"] = 2.4;
          umax["13"] = 2.4;
          umax["60"] = 2.4;
        } else if (zona === 2) {
          umax["1"] = 0.6;
          umax["5"] = 0.4;
          umax["7"] = 0.4;
          umax["18"] = 0.6;
          umax["19"] = 0.6;
          umax["20"] = 0.6;
          umax["21"] = 0.6;
          umax["10"] = 2.4;
          umax["13"] = 2.4;
          umax["60"] = 2.4;
        } else if (zona === 3) {
          umax["1"] = 0.5;
          umax["5"] = 0.3;
          umax["7"] = 0.3;
          umax["18"] = 0.45;
          umax["19"] = 0.45;
          umax["20"] = 0.5;
          umax["21"] = 0.45;
          umax["10"] = 2.4;
          umax["13"] = 2.4;
          umax["60"] = 2.4;
        } else {
          // ZONE 4, 5 i 6
          umax["1"] = 0.4;
          umax["5"] = 0.25;
          umax["7"] = 0.25;
          umax["18"] = 0.4;
          umax["19"] = 0.4;
          umax["20"] = 0.4;
          umax["21"] = 0.4;
          umax["10"] = 2.4;
          umax["13"] = 2.4;
          umax["60"] = 2.4;
        }
      } else if (drzava === "es") {
        if (pos_status_value["1"]) {
          if (standard === 0) {
            umax["1"] = 0.22;
          } else if (standard === 2) {
            umax["1"] = 0.12;
          }
        }
        if (pos_status_value["5"]) {
          if (standard === 0) {
            umax["5"] = 0.2;
          } else if (standard === 2) {
            umax["5"] = 0.1;
          }
        }

        if (pos_status_value["7"]) {
          if (standard === 0) {
            umax["7"] = 0.2;
          } else if (standard === 2) {
            umax["7"] = 0.1;
          }
        }

        if (pos_status_value["18"]) {
          if (standard === 0) {
            umax["18"] = 0.2;
          } else if (standard === 2) {
            umax["18"] = 0.1;
          }
        }

        if (pos_status_value["19"]) {
          if (standard === 0) {
            umax["19"] = 0.2;
          } else if (standard === 2) {
            umax["19"] = 0.1;
          }
        }

        if (pos_status_value["20"]) {
          if (standard === 0) {
            umax["20"] = 0.22;
          } else if (standard === 2) {
            umax["20"] = 0.12;
          }
        }
        if (pos_status_value["21"]) {
          if (standard === 0) {
            umax["21"] = 0.2;
          } else if (standard === 2) {
            umax["21"] = 0.1;
          }
        }

        if (pos_status_value["10"]) {
          if (standard === 0) {
            umax["10"] = 1.1;
          } else if (standard === 2) {
            umax["10"] = 0.6;
          }
        }
        if (pos_status_value["13"]) {
          if (standard === 0) {
            umax["13"] = 1.1;
          } else if (standard === 2) {
            umax["13"] = 0.6;
          }
        }
        if (pos_status_value["60"]) {
          if (standard === 0) {
            umax["60"] = 1.1;
          } else if (standard === 2) {
            umax["60"] = 0.6;
          }
        }
      } else if (drzava === "rs") {
        if (standard == 0) {
          if (stanje === 1) {
            umax["1"] = 0.4;
            umax["5"] = 0.2;
            umax["7"] = 0.2;
            umax["18"] = 0.4;
            umax["19"] = 0.4;
            umax["20"] = 0.5;
            umax["21"] = 0.4;
            umax["10"] = 1.5;
            umax["13"] = 1.6;
            umax["60"] = 1.5;
          } else if (stanje === 2) {
            umax["1"] = 0.3;
            umax["5"] = 0.15;
            umax["7"] = 0.15;
            umax["18"] = 0.3;
            umax["19"] = 0.3;
            umax["20"] = 0.35;
            umax["21"] = 0.3;
            umax["10"] = 1.5;
            umax["13"] = 1.6;
            umax["60"] = 1.5;
          }
        } else {
          if (stanje === 1) {
            umax["1"] = 0.3;
            umax["5"] = 0.1;
            umax["7"] = 0.1;
            umax["18"] = 0.3;
            umax["19"] = 0.3;
            umax["20"] = 0.4;
            umax["21"] = 0.3;
            umax["10"] = 1;
            umax["13"] = 1.1;
            umax["60"] = 1;
          } else if (stanje === 2) {
            umax["1"] = 0.2;
            umax["5"] = 0.1;
            umax["7"] = 0.1;
            umax["18"] = 0.2;
            umax["19"] = 0.2;
            umax["20"] = 0.25;
            umax["21"] = 0.2;
            umax["10"] = 1.0;
            umax["13"] = 1.1;
            umax["60"] = 1.0;
          }
        }
      } else if (drzava === "si") {
        umax["1"] = 0.28;
        umax["5"] = 0.2;
        umax["7"] = 0.2;
        umax["18"] = 0.2;
        umax["19"] = 0.35;
        umax["20"] = 0.35;
        umax["21"] = 0.35;
        umax["10"] = 1.4;
        umax["13"] = 1.6;
        umax["60"] = 1.4;
      } else if (drzava === "ro") {
        umax["1"] = 0.56;
        umax["5"] = 0.2;
        umax["7"] = 0.2;
        umax["18"] = 0.35;
        umax["19"] = 0.35;
        umax["20"] = 0.35;
        umax["21"] = 0.22;
        umax["10"] = 1.3;
        umax["13"] = 1.3;
        umax["60"] = 1.3;
      } else if (drzava === "pl") {
        if (pos_status_value["1"]) {
          if (standard === 0) {
            umax["1"] = 0.23;
          } else if (standard === 2) {
            umax["1"] = 0.2;
          }
        }
        if (pos_status_value["5"]) {
          if (standard === 0) {
            umax["5"] = 0.18;
          } else if (standard === 2) {
            umax["5"] = 0.15;
          }
        }
        if (pos_status_value["7"]) {
          if (standard === 0) {
            umax["7"] = 0.18;
          } else if (standard === 2) {
            umax["7"] = 0.15;
          }
        }
        if (pos_status_value["18"]) {
          if (standard === 0) {
            umax["18"] = 0.25;
          } else if (standard === 2) {
            umax["18"] = 0.25;
          }
        }
        if (pos_status_value["19"]) {
          if (standard === 0) {
            umax["19"] = 0.25;
          } else if (standard === 2) {
            umax["19"] = 0.25;
          }
        }
        if (pos_status_value["20"]) {
          if (standard === 0) {
            umax["20"] = 0.23;
          } else if (standard === 2) {
            umax["20"] = 0.2;
          }
        }
        if (pos_status_value["21"]) {
          if (standard === 0) {
            umax["21"] = 0.3;
          } else if (standard === 2) {
            umax["21"] = 0.3;
          }
        }
        if (pos_status_value["10"]) {
          if (standard === 0) {
            umax["10"] = 1.1;
          } else if (standard === 2) {
            umax["10"] = 0.9;
          }
        }
        if (pos_status_value["13"]) {
          if (standard === 0) {
            umax["13"] = 1.5;
          } else if (standard === 2) {
            umax["13"] = 1.3;
          }
        }
        if (pos_status_value["60"]) {
          if (standard === 0) {
            umax["60"] = 1.1;
          } else if (standard === 2) {
            umax["60"] = 0.9;
          }
        }
      } else if (drzava === "lt") {
        if (stanje === 1) {
          if (pos_status_value["1"]) {
            if (standard === 0) {
              umax["1"] = 0.2;
            } else if (standard === 2) {
              umax["1"] = 0.1;
            }
          }
          if (pos_status_value["5"]) {
            if (standard === 0) {
              umax["5"] = 0.16;
            } else if (standard === 2) {
              umax["5"] = 0.08;
            }
          }
          if (pos_status_value["7"]) {
            if (standard === 0) {
              umax["7"] = 0.16;
            } else if (standard === 2) {
              umax["7"] = 0.08;
            }
          }
          if (pos_status_value["18"]) {
            if (standard === 0) {
              umax["18"] = 0.25;
            } else if (standard === 2) {
              umax["18"] = 0.1;
            }
          }
          if (pos_status_value["19"]) {
            if (standard === 0) {
              umax["19"] = 0.25;
            } else if (standard === 2) {
              umax["19"] = 0.1;
            }
          }
          if (pos_status_value["20"]) {
            if (standard === 0) {
              umax["20"] = 0.25;
            } else if (standard === 2) {
              umax["20"] = 0.1;
            }
          }
          if (pos_status_value["21"]) {
            if (standard === 0) {
              umax["21"] = 0.25;
            } else if (standard === 2) {
              umax["21"] = 0.1;
            }
          }
          if (pos_status_value["10"]) {
            if (standard === 0) {
              umax["10"] = 1.6;
            } else if (standard === 2) {
              umax["10"] = 0.7;
            }
          }
          if (pos_status_value["13"]) {
            if (standard === 0) {
              umax["13"] = 1.6;
            } else if (standard === 2) {
              umax["13"] = 0.7;
            }
          }
          if (pos_status_value["60"]) {
            if (standard === 0) {
              umax["60"] = 1.6;
            } else if (standard === 2) {
              umax["60"] = 0.7;
            }
          }
        } else {
          if (pos_status_value["1"]) {
            if (standard === 0) {
              umax["1"] = 0.12;
            } else if (standard === 2) {
              umax["1"] = 0.1;
            }
          }
          if (pos_status_value["5"]) {
            if (standard === 0) {
              umax["5"] = 0.1;
            } else if (standard === 2) {
              umax["5"] = 0.08;
            }
          }
          if (pos_status_value["7"]) {
            if (standard === 0) {
              umax["7"] = 0.1;
            } else if (standard === 2) {
              umax["7"] = 0.08;
            }
          }
          if (pos_status_value["18"]) {
            if (standard === 0) {
              umax["18"] = 0.14;
            } else if (standard === 2) {
              umax["18"] = 0.1;
            }
          }
          if (pos_status_value["19"]) {
            if (standard === 0) {
              umax["19"] = 0.14;
            } else if (standard === 2) {
              umax["19"] = 0.1;
            }
          }
          if (pos_status_value["20"]) {
            if (standard === 0) {
              umax["20"] = 0.14;
            } else if (standard === 2) {
              umax["20"] = 0.1;
            }
          }
          if (pos_status_value["21"]) {
            if (standard === 0) {
              umax["21"] = 0.14;
            } else if (standard === 2) {
              umax["21"] = 0.1;
            }
          }
          if (pos_status_value["10"]) {
            if (standard === 0) {
              umax["10"] = 1;
            } else if (standard === 2) {
              umax["10"] = 0.7;
            }
          }
          if (pos_status_value["13"]) {
            if (standard === 0) {
              umax["13"] = 1;
            } else if (standard === 2) {
              umax["13"] = 0.7;
            }
          }
          if (pos_status_value["60"]) {
            if (standard === 0) {
              umax["60"] = 1;
            } else if (standard === 2) {
              umax["60"] = 0.7;
            }
          }
        }
      } else if (drzava === "hu") {
        umax["1"] = 0.24;
        umax["5"] = 0.17;
        umax["7"] = 0.17;
        umax["18"] = 0.17;
        umax["19"] = 0.26;
        umax["20"] = 0.3;
        umax["21"] = 0.3;
        umax["10"] = 1.15;
        umax["13"] = 1.45;
        umax["60"] = 1.15;
      }

      final_u_max[standard] = _.clone(umax);
      /* Sprecena mogucnost da je za neku Uprem vrednost 0;
          ako je bilo koja Uprem == 0, Uprem se uopste nece prikazivati NI ZA JEDNU
          poziciju. All or nothing.
          Takav ishod vrlo ocigledno pri testiranju pokazuje da nesto nije u redu
          sa Uprem vrednostima, ako se ocekuju.
          Moguce individualno premostiti: Uprem = Ustand */
      if (Object.values(umax_premium).every((u_val) => u_val != 0)) {
        // Dodaje umax_premium nakon poslednjeg umax
        final_u_max[standardTypes.length] = _.clone(umax_premium);
      }
    }

    return final_u_max;
  },

  /**
   * Vraca array of arrays koji se koristi za prikaz boja i granicnih vrednosti slidera.
   * "Unutrasnji" array sadrzi podatke za pojedinacni raspon (npr od 0 do belog praga).
   * Svaka pozicija dobija svoj array of arrays, podatke o svim rasponima (koji
   * pokrivaju ceo slajder).
   */
  get_standard_data_array: function (
    pos_standard,
    loc_u_max,
    current_position,
    pos_status,
    typ_dubina,
    typ_vrstatla,
    povrsina_jednog_sprata,
    duzina_strane_kuce,
    get_position_type,
    app_sklopovi,
    get_sklopovi_data,
    top,
    get_sklop_data,
    bottom_window_type
  ) {
    /* Svaki raspon na slajderu ima svoj array:
      [
        debljina izolacije od koje pocinje raspon, // vrednost odredjuje poziciju praga na slajderu
        debljina izolacije kojom se zavrsava raspon,
        treshold U vrednost,
        ?,
        boja
      ]

      Broj raspona zavisi od pos_standard.data.length
      (pre dodavanja GRE premium level, za Grcku je uvek bio == 0).
      Kada je u get_max_u() definisano vise nivoa U vrednosti,
      broj raspona zavisi od broja propertija objekta koji vraca get_max_u (loc_u_max).
    */

    let bottom_debljina_izolacije_array = [];

    const has_pos_standard_multiple = pos_standard.data.length && pos_standard.data.length !== 1;
    const has_loc_u_multiple = Object.keys(loc_u_max).length > 1;

    /* Prethodna logika je imala samo slucaj has_pos_standard_multiple.
        Za grcki premium level sam dodao mogucnost dodavanja slider raspona na
        osnovu postojanja dodatnog arraya U vrednosti (has_loc_u_multiple).
        Ne mogu da tvrdim da bi resenje savrseno radilo kod zemalja koje eventualno
        imaju has_pos_standard_multiple plus has_loc_u_multiple. Ako u buducnosti jos
        neka drzava bude htela premium level, proveriti i updateovati ovaj komentar.
        Moguce da bi u tom slucaju primarno koriscenje duzine loc_u_max radilo posao,
        ali to bi bilo neophodno testirati. */
    if (has_pos_standard_multiple || has_loc_u_multiple) {
      let u_length;
      if (has_pos_standard_multiple) {
        u_length = pos_standard.data.length;
      } else {
        u_length = Object.keys(loc_u_max).length;
      }

      for (let index = 0; index < u_length; index++) {
        let element;
        if (has_pos_standard_multiple) {
          element = pos_standard.data[index];
        } else {
          element = index;
        }

        bottom_debljina_izolacije_array[element] = [
          0,
          this.get_calculate_bottom_debljina(
            current_position,
            pos_status,
            typ_dubina,
            typ_vrstatla,
            povrsina_jednog_sprata,
            duzina_strane_kuce,
            loc_u_max,
            get_position_type,
            app_sklopovi,
            get_sklopovi_data,
            top,
            get_sklop_data,
            bottom_window_type,
            element
          ),
          loc_u_max[element][current_position],
          element,
        ];
      }
    } else {
      bottom_debljina_izolacije_array[0] = [
        0,
        this.get_calculate_bottom_debljina(
          current_position,
          pos_status,
          typ_dubina,
          typ_vrstatla,
          povrsina_jednog_sprata,
          duzina_strane_kuce,
          loc_u_max,
          get_position_type,
          app_sklopovi,
          get_sklopovi_data,
          top,
          get_sklop_data,
          bottom_window_type
        ),
        loc_u_max[0][current_position],
        0,
      ];
    }

    // Dodaje se poslednji array za poslednji nivo, kraj skale, debljina izolacije 30cm
    bottom_debljina_izolacije_array[bottom_debljina_izolacije_array.length] = [0, 30, 0, 3];

    /* Izracunata vrednost debljine izolacije se upisuje u array narednog raspona
        -> index 0 (korisi se za prikaz granicnika);
        U vrednost se upisuje u naredni array -> index 2. */
    let prev_u_max, prev_debljina_izolacije;
    for (let index = 0; index < bottom_debljina_izolacije_array.length; index++) {
      let element = bottom_debljina_izolacije_array[index];
      if (element == null) continue;
      if (index === 0) {
        prev_debljina_izolacije = element[1];
        prev_u_max = element[2];
        // element[2] = 0;
      } else {
        element[0] = prev_debljina_izolacije;
        const temp_u_max = element[2];
        element[2] = prev_u_max;
        prev_u_max = temp_u_max;
        prev_debljina_izolacije = element[1];
      }
      if (element[0] === element[1]) {
        bottom_debljina_izolacije_array[index] = undefined;
      }
    }
    bottom_debljina_izolacije_array = bottom_debljina_izolacije_array.filter((elem) => elem != null);

    if (pos_standard.data.length === 3) {
      for (const iterator of bottom_debljina_izolacije_array) {
        if (iterator[3] === 0) {
          iterator.push("red");
        } else if (iterator[3] === 1) {
          iterator.push("orange");
        } else if (iterator[3] === 2) {
          iterator.push("green");
        } else {
          iterator.push("dark-green");
        }
      }
    } else {
      for (const iterator of bottom_debljina_izolacije_array) {
        if (iterator[3] === 0) {
          iterator.push("red");
        } else if (iterator[3] === 1 || iterator[3] === 2) {
          iterator.push("green");
        } else {
          iterator.push("dark-green");
        }
      }
    }
    return bottom_debljina_izolacije_array;
  },

  /**
   * Vraca debljinu izolacije (koja se koristi kao breakpoint na slideru).
   */
  get_calculate_bottom_debljina: function (
    current_position,
    pos_status,
    typ_dubina,
    typ_vrstatla,
    povrsina_jednog_sprata,
    duzina_strane_kuce,
    loc_u_max,
    get_position_type,
    app_sklopovi,
    get_sklopovi_data,
    top,
    get_sklop_data,
    bottom_window_type,
    index = 0
  ) {
    function get_missing_D(existing_U, max_U) {
      // return value in cm capped to 30;
      if (max_U >= existing_U) return -1;

      const r_max_u = 1 / max_U;
      const r_existing_u = 1 / existing_U;
      const delta_r = r_max_u - r_existing_u;
      // eslint-disable-next-line
      superconsole.log(
        "existing_u: ",
        existing_U,
        "max_u: ",
        max_U,
        "bottom_debljina_izolacije: ",
        Math.min(30, Math.ceil(delta_r * app_math.lambda_new * 100))
      );
      return Math.min(30, Math.ceil(delta_r * app_math.lambda_new * 100));
    }

    // get_position_type === 1: sve pozicije osim 10, 13, 20, 21
    if (get_position_type === 1) {
      const u_existing = app_math.get_final_u(
        current_position,
        null,
        {
          top_debljina_izolacije_default: top.debljina_izolacije_default / 100,
          top_debljina_izolacije: top.debljina_izolacije / 100,
        },
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        false,
        get_sklop_data
      ).u.top.current;
      const insulation_new = get_missing_D(u_existing, loc_u_max[index][current_position]);
      // todo work -1 value, postojeca izolacija zadovoljava standard
      return insulation_new === -1 ? 0 : insulation_new;
    // get_position_type === 3: pozicije 20, 21
    } else if (get_position_type === 3) {
      let i;
      // i je debljina izolacije (cm)
      for (i = 0; i <= 30; i++) {
        let cm = i / 100;
        if (current_position == "20") {
          let res = app_math.get_final_u(
            current_position,
            null,
            {
              top_debljina_izolacije: pos_status.value["20"].top_debljina_izolacije + cm,
              top_debljina_zida: pos_status.value["20"].top_debljina_zida,
            },
            null,
            null,
            typ_vrstatla,
            typ_dubina,
            povrsina_jednog_sprata,
            duzina_strane_kuce,
            {
              top_debljina_izolacije:
                pos_status.value["21"].top_debljina_izolacije +
                (pos_status.value["21"].status == 1 ? pos_status.value["21"].bottom_debljina_izolacije : 0),
            },
            false
          );
          if (res.u.top.current <= loc_u_max[index]["20"]) {
            return i;
          }
        } else {
          if (pos_status.value["20"]) {
            let res = app_math.get_final_u(
              "20",
              null,
              {
                top_debljina_izolacije:
                  pos_status.value["20"].top_debljina_izolacije +
                  (pos_status.value["20"].status == 1 ? pos_status.value["20"].bottom_debljina_izolacije : 0),
                top_debljina_zida: pos_status.value["20"].top_debljina_zida,
              },
              null,
              null,
              typ_vrstatla,
              typ_dubina,
              povrsina_jednog_sprata,
              duzina_strane_kuce,
              {
                top_debljina_izolacije: pos_status.value["21"].top_debljina_izolacije + cm,
                top_debljina_izolacije_default: pos_status.value["21"].top_debljina_izolacije_default,
                bottom_debljina_izolacije: pos_status.value["21"].bottom_debljina_izolacije,
              },
              false
            );
            if (res.u_21.top.current <= loc_u_max[index]["21"]) {
              return i;
            }
          } else {
            if (
              app_math.get_final_u(
                current_position,
                null,
                {
                  top_debljina_izolacije: pos_status.value["21"].top_debljina_izolacije + cm,
                  top_debljina_zida: pos_status.value["21"].top_debljina_zida,
                },
                null,
                null,
                typ_vrstatla,
                typ_dubina,
                povrsina_jednog_sprata,
                duzina_strane_kuce,
                null,
                false
              ).u.top.current <= loc_u_max[index]["21"]
            ) {
              return i;
            }
          }
        }
      }
      return 30;
    // get_position_type === 2: prozori i vrata (pozicije 10 i 13)
    } else {
      let best_max = { sklop: top.image, u: app_sklopovi.data[top.image].u };
      const u_max = loc_u_max[index][current_position];
      const tip_prozora = bottom_window_type;
      for (const sklop of get_sklopovi_data.sklopovi[current_position]) {
        const cur_sklop = app_sklopovi.data[sklop];
        if (cur_sklop.tip_prozora != tip_prozora) continue;
        if (
          (best_max.u > u_max && cur_sklop.u < best_max.u) ||
          (best_max.u < u_max && cur_sklop.u < u_max && cur_sklop.u > best_max.u)
        ) {
          best_max = { sklop: sklop, u: cur_sklop.u };
        }
      }
      return best_max;
    }
  },
};
